import { apiSlice } from "redux/Api.Slice";
import * as URL from "api/api/apiUrls";
const postConfig = {
  query: (body) => ({
    method: "POST",
    body: body,
  }),
  transformResponse: (response) => {
    return response;
  },
};

const JeeblyService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendOrderToJeebly: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.JEEBLY_CREATE_DELIVERY,
        ...postConfig.query(body),
      }),
    }),
    trackJeeblyOrder: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.JEEBLY_GET_DELIVERY_STATUS,
        ...postConfig.query(body),
      }),
    }),
    cancelJeeblyOrder: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.JEEBLY_CANCEL_DELIVERY,
        ...postConfig.query(body),
      }),
    }),
  }),
});
export const {
  useSendOrderToJeeblyMutation,
  useTrackJeeblyOrderMutation,
  useCancelJeeblyOrderMutation,
} = JeeblyService;
export default JeeblyService;
